import React from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="mt-5 w-[87%] md:w-[56%] mx-auto bg-gray-100 pt-5 pb-0 border-t border-gray-300 text-left z-[1000]">
      <div>
        <strong className="font-semibold">Free online image convertes</strong>
      </div>
      <div className="grid md:grid-cols-4 grid-cols-2 gap-auto gap-y-2 mt-2">
        <Link to="/en/image-converter/png/jpeg" className="text-sm inline-flex items-center">PNG to JPEG<FiExternalLink className="ml-1" /></Link>
        <Link to="/en/image-converter/jpeg/webp" className="text-sm inline-flex items-center">JPEG to WEBP<FiExternalLink className="ml-1" /></Link>
        <Link to="/en/image-converter/png/webp" className="text-sm inline-flex items-center">PNG to WEBP<FiExternalLink className="ml-1" /></Link>
        <Link to="/en/image-converter/webp/png" className="text-sm inline-flex items-center">WEBP to PNG<FiExternalLink className="ml-1" /></Link>
        <Link to="/en/image-converter/heic/jpeg" className="text-sm inline-flex items-center">HEIC to JPEG<FiExternalLink className="ml-1" /></Link>
        <Link to="/en/image-converter/tiff/jpeg" className="text-sm inline-flex items-center">TIFF to JPEG<FiExternalLink className="ml-1" /></Link>
      </div>
    </footer>
  );
};

export default Footer;
